<template>
  <div></div>
</template>

<script>
import * as firebase from '../connections/firebase';

export default {
  name: 'TestPage',
  data() {
    return {
    };
  },
  mounted() {
    firebase.init(this);
  },
};
</script>

<style>

</style>
